import React, { Component } from "react";
import DatePicker from "react-datetime";

import DateTimeService from "../../../../utils/dateTimeService";

export default class DateInput extends Component {
  render() {
    return (
      <div className={`col-md-${this.props.widthRatio}`}>
        <label>{this.props.label}</label>
        <DatePicker
          dateFormat="YYYY-MM-DD"
          value={this.props.value}
          timeFormat={false}
          onChange={(value) =>
            this.props.onChange(
              new DateTimeService(value).formatDate,
              this.props.inputKey
            )
          }
        />
      </div>
    );
  }
}
